import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveTextstyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRemoveTextstyle"><Path d="M9.75 20.4999L10.917 11.3152" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 3.5L20.5 19.4697" stroke="currentColor" strokeLinecap="square"/><Path d="M11.2734 8.49999L11.8689 3.81348" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 3.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRemoveTextstyle;
